<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Workflow Functional Approval Sequence
        <div class="card-header-actions">
          <b-button variant="warning" class="mr-1 text-white" @click="openChangeApproverModal">
            <i class="fa fa-exchange"></i> Change Approver
          </b-button>
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col lg="12">
          <b-input-group >
              <b-input-group-prepend><span class="p-2">Workflow Name</span></b-input-group-prepend>
              <b-form-select  v-model="tblData.wftypekey" :options="workflowtypes"  :plain="true" ></b-form-select>
              <b-input-group-prepend><span class="p-2">Requestor</span></b-input-group-prepend>
              <b-form-input v-model="tblData.requestor" @keyup.13.native="refresh()" placeholder="Requestor (% for wildcard)"></b-form-input>
              <b-input-group-prepend><span class="p-2">Approver</span></b-input-group-prepend>
              <b-form-input v-model="tblData.approver" @keyup.13.native="refresh()" placeholder="Approver (% for wildcard)"></b-form-input>
              <b-input-group-append>
                  <b-button class="btn btn-success ml-3" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
              </b-input-group-append>
              <b-input-group-append>
                <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
              </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(index)="data">
          {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="tblData.limit"/>
            </b-row>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>

      <!-- Modal Change Approver -->
      <b-modal
        v-model="showChangeApproverModal"
        title="Change Approver (Permanent)"
        :centered="true"
        size="md"
        no-close-on-backdrop
      >
        <b-alert show variant="warning" class="p-2 mb-3" style="font-size: 13px;">
          <i class="fa fa-exclamation-triangle mr-1"></i>
          <strong>Perhatian:</strong> Perubahan ini bersifat <strong>permanen</strong>. Approver lama akan diganti dengan approver baru, berlaku untuk proses approval yang akan datang serta <strong>seluruh workflow approval yang sedang berjalan</strong>.
        </b-alert>

        <b-form-group label="Workflow Type" label-class="font-weight-bold">
          <b-form-select
            v-model="changeApproverForm.wftypekey"
            :options="workflowTypeChangeOptions"
            :plain="true"
          ></b-form-select>
          <small class="text-muted">Pilih jenis workflow atau biarkan "-- All Workflow Types --" untuk semua workflow.</small>
        </b-form-group>

        <b-form-group label="Approver Lama (User A)" label-class="font-weight-bold">
          <b-input-group>
            <b-form-input
              v-model.trim="changeApproverForm.oldApprover"
              placeholder="Username approver lama yang diganti"
            ></b-form-input>
            <b-input-group-append>
              <b-button variant="info" @click="openUserLookup('oldApprover')">
                <i class="fa fa-search"></i> Cari
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <b-form-group label="Approver Baru (User B)" label-class="font-weight-bold">
          <b-input-group>
            <b-form-input
              v-model.trim="changeApproverForm.newApprover"
              placeholder="Username approver baru pengganti"
            ></b-form-input>
            <b-input-group-append>
              <b-button variant="info" @click="openUserLookup('newApprover')">
                <i class="fa fa-search"></i> Cari
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <div slot="modal-footer" class="w-100 d-flex justify-content-between">
          <b-button variant="secondary" @click="closeChangeApproverModal()" :disabled="isSubmittingChangeApprover">
            <i class="fa fa-close"></i> Batal
          </b-button>
          <b-button variant="danger" @click="submitChangeApprover()" :disabled="isSubmittingChangeApprover">
            <i :class="isSubmittingChangeApprover ? 'fa fa-spinner fa-spin' : 'fa fa-check'"></i>
            {{ isSubmittingChangeApprover ? 'Memproses...' : 'Terapkan Penggantian' }}
          </b-button>
        </div>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card >
          <div slot="header">Workflow Functional Approval - Add/Edit Form 
          </div>
                <b-input-group >
                    <b-input-group-prepend><label>Workflow Name</label></b-input-group-prepend>
                      <b-form-select  v-model="frmdata.wftypekey" :options="workflowtypes" :state="!$v.frmdata.wftypekey.$error" :plain="true" ></b-form-select>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>Requestor</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.requestor" placeholder="Requestor's Username " :state="!$v.frmdata.requestor.$error"></b-form-input>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>Approver Sequence</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.approverSeq" placeholder="CSV of Approver's Username" :state="!$v.frmdata.approverSeq.$error"></b-form-input>
                    <b-input-group-append>
                      <b-button variant="info" @click="openUserLookup('approverSeq')">
                        <i class="fa fa-search"></i> Cari
                      </b-button>
                    </b-input-group-append>
                </b-input-group>
            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>

        </b-card>
        </b-col>
    </b-row>

    <!-- Lookup User Modal -->
    <b-modal v-model="lkuUserShow" size="lg" :hide-footer="true" title="List of Users" :centered="true">
      <lku-user @click="onSelectUser"></lku-user>
    </b-modal>
  </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 160px;
            }
        }
    }
</style>


<script>
import toastr from "mini-toastr";
import wfname from "../../apis/wffunctionalapproval";
import lkuUser from "../lookup/lkuUser";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: { lkuUser },
  mixins: [validationMixin],
  validations: {
    frmdata: {
        wftypekey: { required },
        requestor: { required },
        approverSeq: { required }
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      showList:true,
      showForm:false,
      frmdata:{wftypekey: '', requestor:'', approverSeq:''},
      tblData: {
        page: 1,
        limit: 50,
        total: 0,
        sortBy: 'wftypekey',
        sortDesc: false
      },
      workflowtypes:[],
      showChangeApproverModal: false,
      changeApproverForm: {
        wftypekey: '',
        oldApprover: '',
        newApprover: ''
      },
      isSubmittingChangeApprover: false,
      lkuUserShow: false,
      lkuUserTarget: ''
    };
  },
  computed: {
    workflowTypeChangeOptions() {
      const options = [{ value: '', text: '-- All Workflow Types --' }];
      if (this.workflowtypes && this.workflowtypes.length) {
        this.workflowtypes.forEach((item) => {
          if (typeof item === 'object' && item !== null) {
            options.push(item);
          } else {
            options.push({ value: item, text: item });
          }
        });
      }
      return options;
    },
    tblFields(){
      const fields=[
          {
            key: "index",
            label: "No.",
            thStyle: "width:30px",
          },
          {
            key: "wftypekey",
            label: "Job Type Name",
            sortable: true
          },
          {
            key: "requestor",
            label: "Requestor",
            thClass: "text-center",
            sortable: true
          },
          {
            key: "approverSeq",
            label: "Approval Sequence",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  created: async function() {
    this.workflowtypes= await wfname.workflowtype();
  },
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await wfname.list(this.tblData);      
      return list;
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await wfname.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },   

    search() {
      this.tblData.page=1;
      this.refresh();
    },     
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.wftypekey= '';
        this.tblData.requestor= '';
        this.tblData.approver= '';
        this.refresh();
    },

    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.idlama = data.functAppKey;
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              await wfname.save(this.frmdata)
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await wfname.remove(this.model);
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },
    openChangeApproverModal() {
      this.changeApproverForm = {
        wftypekey: this.tblData.wftypekey || '',
        oldApprover: '',
        newApprover: ''
      };
      this.showChangeApproverModal = true;
    },
    closeChangeApproverModal() {
      this.showChangeApproverModal = false;
    },
    openUserLookup(target) {
      this.lkuUserTarget = target;
      this.lkuUserShow = true;
    },
    onSelectUser(selected) {
      if (this.lkuUserTarget && selected && selected.username) {
        if (this.lkuUserTarget === 'approverSeq') {
          const current = (this.frmdata.approverSeq || '').trim();
          if (!current) {
            this.frmdata.approverSeq = selected.username;
          } else {
            const arr = current.split(',').map(s => s.trim()).filter(Boolean);
            if (!arr.includes(selected.username)) {
              arr.push(selected.username);
              this.frmdata.approverSeq = arr.join(',');
            } else {
              toastr.info(`User "${selected.username}" sudah ada di Approver Sequence.`);
            }
          }
        } else {
          this.changeApproverForm[this.lkuUserTarget] = selected.username;
        }
      }
      this.lkuUserShow = false;
    },
    async submitChangeApprover() {
      const { oldApprover, newApprover, wftypekey } = this.changeApproverForm;

      if (!oldApprover || !oldApprover.trim()) {
        toastr.error('Approver Lama (User A) wajib diisi.', 'VALIDASI ERROR');
        return;
      }
      if (!newApprover || !newApprover.trim()) {
        toastr.error('Approver Baru (User B) wajib diisi.', 'VALIDASI ERROR');
        return;
      }
      if (oldApprover.trim().toLowerCase() === newApprover.trim().toLowerCase()) {
        toastr.error('Approver Baru tidak boleh sama dengan Approver Lama.', 'VALIDASI ERROR');
        return;
      }

      const wfInfo = wftypekey ? `untuk workflow "${wftypekey}"` : 'untuk SEMUA workflow';
      const confirmMsg = `Apakah Anda yakin ingin mengganti approver dari "${oldApprover.trim()}" menjadi "${newApprover.trim()}" ${wfInfo}? Perubahan ini bersifat permanen dan akan mengubah seluruh workflow approval yang sedang berjalan.`;

      const ok = await this.$bvModal.msgBoxConfirm(confirmMsg, {
        title: 'Konfirmasi Penggantian Approver',
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Ya, Ganti Approver',
        cancelTitle: 'Batal',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      });

      if (!ok) return;

      this.isSubmittingChangeApprover = true;
      try {
        const payload = {
          oldApprover: oldApprover.trim(),
          newApprover: newApprover.trim(),
          wftypekey: wftypekey || ''
        };
        const response = await wfname.changeApprover(payload);
        const msg = (response && (response.message || response.msg)) ? (response.message || response.msg) : 'Penggantian approver berhasil diproses.';
        toastr.success(msg, 'SUCCESS');
        this.closeChangeApproverModal();
        this.refresh();
      } catch (error) {
        console.error('changeApprover error:', error);
        if (error && error.message) {
          toastr.error(error.message, 'ERROR');
        } else if (error && error.sqlMessage) {
          toastr.error(error.sqlMessage, 'DATABASE ERROR');
        } else {
          toastr.error(JSON.stringify(error), 'ERROR');
        }
      } finally {
        this.isSubmittingChangeApprover = false;
      }
    }
  }
};
</script>
